
'use strict'

import objectAssign from 'object-assign'
import dom from '../utilities/dom'


function closeModal(baseElem, contentElem, classNames) {
  contentElem.innerHTML = ''
  baseElem.classList.remove(classNames.active)
}


function openModal(baseElem, contentElem, classNames) {
  baseElem.classList.add(classNames.active)
  contentElem.focus()
}


function setModalContent(contentElem, html) {
  contentElem.innerHTML = ''

  if (typeof html === 'string') {
    contentElem.innerHTML = html
  } else {
    contentElem.appendChild(html)
  }
}


function setModalEvents(baseElem, contentElem, handlers) {
  document.addEventListener('click', (event) => {
    let attribute = 'data-close-modal'
    let matchedElem = dom.eventAttributeMatch(event.target, event.currentTarget, attribute)
    if (matchedElem) handlers.close()
  })

  contentElem.addEventListener('keydown', (event) => {
    if (event.which === 27 ) {
      handlers.close()
    }
  })
}


function simpleModal(baseElem) {
  let classNames = {
    active: 'isActive'
  }

  let contentElem = baseElem.querySelector('[data-modal-content]')
  
  return objectAssign({}, {

    setEvents: setModalEvents.bind(null, baseElem, contentElem, {
      close: closeModal.bind(null, baseElem, contentElem, classNames)
    }),

    close: function() {
      closeModal(baseElem, contentElem, classNames)
    },

    open: function() {
      openModal(baseElem, contentElem, classNames)
    },

    setContent: function(html) {
      setModalContent(contentElem, html)
    }

  })
}


export default simpleModal




/** WEBPACK FOOTER **
 ** ./src/scripts/client/components/simpleModal.js
 **/